import { apiFetch } from '@nrdy-marketing-engine/api-fetch';
import { Client } from '@nrdy-marketing-engine/cart/@types/cart-state';

const createCart = (client?: Client, quoteJurisdictionId?: string) =>
  apiFetch(`/v1/carts`, {
    method: 'POST',
    body: JSON.stringify({
      data: {
        attributes: {
          cart_type: 'checkout',
          owner_id: client.uuid,
          owner_type: 'visitor',
          jurisdiction_id: quoteJurisdictionId || client.jurisdictionId,
        },
        type: 'carts',
      },
    }),
  });

export default createCart;
